import { ResponseAddressManagerCreate, RequestAddressManagerCreate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { AddressManagerCreateActions } from '../actions';
import { AddressManagerCreateTypes } from '../../shared/enums';

export interface AddressManagerCreateState {
    response: ResponseAddressManagerCreate;
    request: RequestAddressManagerCreate;
    error: any;
}

export const AddressManagerCreateInitialState: AddressManagerCreateState = {
    response: null,
    request: null,
    error: null
};

const _addressManagerCreateReducer = createReducer(
    AddressManagerCreateInitialState,

    on(AddressManagerCreateActions.getAddressManagerCreate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(AddressManagerCreateActions.getAddressManagerCreateSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(AddressManagerCreateActions.getAddressManagerCreateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(AddressManagerCreateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function addressManagerCreateReducer(state, action) {
    if (action.type === AddressManagerCreateTypes.ADDRESS_MANAGER_CREATE) {
        state = undefined;
    }
    return _addressManagerCreateReducer(state, action);
}
